import { useState, useCallback, useMemo, useRef } from 'react';
import { manageAppsAPI } from 'services/manageApps.service';

export const useFacade = (onChange, category, setValue) => {
  const [isOpen, setIsOpen] = useState(false);
  const startPrintFlag = useRef(false);
  const { data: categories, isSuccess, isError } = manageAppsAPI.useGetAllAppsCategoriesQuery();

  const handleClick = useCallback((category, blurCategoryInput) => {
    onChange(category);
    setIsOpen(false);
    startPrintFlag.current = false;
    requestAnimationFrame(blurCategoryInput);
  }, []);

  const foundedCategories = useMemo(() => {
    if (!category && !startPrintFlag.current) return categories;
    if (category && startPrintFlag.current)
      return categories?.filter((cat) =>
        cat.application_type_name.toLowerCase().includes(category.toLowerCase()),
      );
    return categories;
  }, [category, categories, startPrintFlag.current]);

  const handlePrint = useCallback((e) => {
    startPrintFlag.current = true;
    onChange(e.target.value);
  }, []);

  const changeFocus = useCallback(() => {
    const finalCategoty = categories?.find((cat) =>
      category.toLowerCase().includes(cat.application_type_name.toLowerCase()),
    );
    setValue('category', finalCategoty?.application_type_name, { shouldDirty: true });
  }, [category]);

  return {
    isOpen,
    setIsOpen,
    handleClick,
    foundedCategories,
    handlePrint,
    isSuccess,
    isError,
    changeFocus,
  };
};
